import { CheckoutItemModel } from './item.model';

export class CheckoutBasketModel {
  private _grossTotal: number = 0;
  private _netTotal: number = 0;
  private _tax: number = 0;

  private _countItems: number = 0;

  private _countInvoiceableItems: number = 0;
  private _countNonInvoiceableItems: number = 0;
  private _countGiftItems: number = 0;
  private _basketItems: Array<Object>;

  public paymentMethod: 'card' | 'paypal' | 'none' = 'card';
  public country: string;

  public get countItems(): number {
    return this._countItems;
  }

  public get countInvoiceableItems(): number {
    return this._countInvoiceableItems;
  }

  public get countNonInvoiceableItems(): number {
    return this._countNonInvoiceableItems;
  }
  
  public get countGiftItems(): number {
    return this._countGiftItems;
  }

  public get grossTotal(): number {
    return this._grossTotal;
  }

  public get netTotal(): number {
    return this._netTotal;
  }

  public get tax(): number {
    return this._tax;
  }

  public get displayGrossTotal(): number {
    return this._grossTotal;
  }

  public get displayNetTotal(): number {
    return this._netTotal;
  }

  public get displayTax(): number {
    return this._tax;
  }
  
  public set basketItems(items: any) {
    this._basketItems = items;
  }
  
  public get basketItems(): any {
    return this._basketItems;
  }

  public calculate(items: CheckoutItemModel[]) {
    this._grossTotal = 0;
    this._netTotal = 0;
    this._tax = 0;

    this._countItems = items.length;
    this._countInvoiceableItems = 0;
    this._countNonInvoiceableItems = 0;
    this._countGiftItems = 0;

    for (const item of items) {
      if (!item.voucher) {
        this._netTotal += item.price;

        this._countInvoiceableItems++;
                
        if (item.isGift) {
          this._countGiftItems++;
        }
      } else {
        this._countNonInvoiceableItems++;
      }
    }

    const netCents = this._netTotal * 100;

    if (this._netTotal) {
      if (this.paymentMethod === 'paypal') {
        this._tax = Math.round(netCents * 0.015 + 35) / 100;
      } else if (this.paymentMethod === 'card') {
        if (this._netTotal < 5) {
          this._tax = Math.round(netCents * 0.05 + 5) / 100;
        } else {
          if (this.country === 'US') {
            this._tax = Math.round(netCents * 0.029 + 25) / 100;
          } else {
            this._tax = Math.round(netCents * 0.012 + 25) / 100;
          }
        }
      }
    } else {
      this._tax = 0;
    }

    // this._tax = this._netTotal ? Math.round((this._netTotal * 0.019 + 0.3) * 100) / 100 : 0;

    this._grossTotal = this._netTotal + this._tax;
  }
}


// WEBPACK FOOTER //
// ./src/app/checkout/models/basket.model.ts